import Button from "../button/Button";

export default function EditorFormActions({
	onSubmit,
	isLoading,
	submitLabel = "ذخیره",
	secondaryAction,
}) {
	return (
		<div className="mt-6 flex flex-col-reverse gap-3 border-t border-darkBlue/10 pt-5 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
			{secondaryAction}
			<div className="min-h-[44px] w-full min-w-[120px] sm:w-auto">
				<Button
					onClick={onSubmit}
					label={submitLabel}
					isLoading={isLoading}
				/>
			</div>
		</div>
	);
}
